module.exports = __webpack_public_path__ + "img/sky.457eb53.svg";